








































import lo from 'lodash';

export default {
  name: 'PdtSizePicker',
  props: {
    option: { type: Array, required: true },
    cols: { type: Number, default: 4 },
    freeColumn: { type: Boolean, default: false },
    value: { type: [String, Array], default: '' },
    labelKey: { type: String, default: 'label' },
    valueKey: { type: String, default: 'value' },
    multiple: { type: Boolean, default: false },
    ignoreDisabled: { type: Boolean, default: false }
  },
  data() {
    return {
      groups: []
    };
  },
  computed: {
    styles() {
      return {
        flexBasis: this.freeColumn
          ? 'unset'
          : `calc((100% - ${8 * (this.cols - 1)}px) / ${this.cols})`
      };
    }
  },
  mounted() {
    this.$watch(
      'value',
      value => {
        this.groupBy(value);
      },
      { immediate: true }
    );

    this.$watch('option', () => {
      this.groupBy(this.value);
    });
  },
  methods: {
    handleClick(data) {
      if (data.disabled && !this.ignoreDisabled) return;
      let value = data;
      if (this.multiple) {
        if (data.isActived) {
          value = [...this.value];
          lo.remove(value, v => v === data.value);
        } else {
          value = [...this.value, data.value];
        }
      } else {
        if (data.isActived) return;
        value = data.value;
      }
      this.$emit('change', value);
      this.$emit('input', value);
    },
    formart(list) {
      const flows = lo.flow([
        list =>
          lo.map(list, item => {
            item.label = item[this.labelKey];
            item.value = item[this.valueKey];

            return item;
          }),

        this.multiple
          ? list =>
              lo.map(list, item => {
                item.isActived = lo.find(this.value, v => v === item.value);
                return item;
              })
          : list =>
              lo.map(list, item => {
                item.isActived = this.value === item.value;
                return item;
              })
      ]);

      return flows(list);
    },
    groupBy() {
      const list = this.formart(this.option);
      this.groups = this.freeColumn ? [list] : lo.chunk(list, this.cols);
    }
  }
};
